import { useModal } from '@/hooks'
import { backgroundPattern, urbanLogo } from '@/images'
import React from 'react'
import Button from '../Button'
import Container from '../Container'
import Title from '../Title'
import style from './styles/join.module.scss'

const JoinUrbanClub = (): React.ReactElement => {
  const { openModal } = useModal()

  const handleOpenModal = (data): void => {
    openModal('urbanClubBenefits', { lifehackId: data.id })
  }
  return (
    <section className={style.join}>
      <div
        className={style.join_bg}
        style={{ backgroundImage: `url(${String(backgroundPattern)})` }}
      >
        <Container className={style.join_wrap}>
          <img
            src={urbanLogo}
            width='390px'
            height='407px'
            alt='Логотип клуба урбанистов'
            className={style.join__image}
          />
          <div className={style.join_content}>
            <Title type='h2' theme='h1' className={style.join__title}>
              Вступай в клуб урбанистов!
            </Title>
            <p className={style.join__text}>
              Общайся, участвуй в заседаниях клуба, решай задачи и получай подарки!
            </p>
            <Button
              size='large'
              highlight
              wide
              onClick={handleOpenModal}
              className={style.join__button}
            >
              Вступить в клуб
            </Button>
          </div>
        </Container>
      </div>
    </section>
  )
}

export default JoinUrbanClub
